$('.js-tabs-link').click(function (e) {
  var $this = $(this);
  var index = $this.parent().index();
  var $tabs = $this.closest('.js-tabs');

  e.preventDefault();

  $this
    .parent()
    .add($tabs.find('.tab:nth-child(' + (index + 1) + ')'))
    .addClass('is-active')
    .siblings()
    .removeClass('is-active');
});
